import { useState } from 'react'
import { mutate } from 'swr'
import { Update_Book_Section_Order } from '@graphql/mutations'
import { Single_Book } from '@graphql/queries'
import { useApi } from '@hooks/useApi'

const useUpdateBookSectionOrder = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Update_Book_Section_Order,
      successMessage ? successMessage : 'Ordning uppdaterad.',
      errorMessage
        ? errorMessage
        : 'Nåt gick fel när ordningen skulle uppdateras.',
      async () => {
        await mutate([Single_Book, data.id]) // refetch single book
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateBookSectionOrder }
